import { emailRegex } from "./constants";

export const isValidEmail = (value: string) => emailRegex.test(value);

export const isNotEmpty = (value: string) => value != null && value != "";
